module.exports = __webpack_public_path__ + "img/hand.d38b0a46.png";